import * as React from 'react'
import { IconButtonSeeker, useToaster } from 'ui-seeker/core'
import { useRemoveUsers } from '../../hooks'

export default function IconRemoveMasterUsers({idLineSelected}) {

    const { showToaster } = useToaster()
    const { removeUsers } = useRemoveUsers()

	const handleClick = () => {
        showToaster.confirm(`Are you sure to remove selected master users?`, {
            onSuccess: () => {

                const data = {
                    id_user: idLineSelected,
                    enabled: false,
                    master: true
                }

                removeUsers(data)
            },
            onCancel: () => {
                showToaster.error('Cancelled!')
            }
        })
        
	}

	return <IconButtonSeeker icon="trash-alt" iconType="fontAwesome" title="Remove master users" onClick={handleClick} />
}